<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">فرم ورود</h4>
                  <p>خوش آمدید...</p>
                </div>

                <div @keydown.enter="loginAdmin()">
                  <vs-input
                    v-validate="'required'"
                    data-vv-validate-on="blur"
                    name="email"
                    icon-no-border
                    icon="icon icon-user"
                    icon-pack="feather"
                    label-placeholder="ایمیل"
                    v-model="email"
                    class="w-full"/>
                  <span class="text-danger text-sm">{{ errors.first('email') }}</span>

                  <vs-input
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      type="password"
                      name="password"
                      icon-no-border
                      icon="icon icon-lock"
                      icon-pack="feather"
                      label-placeholder="رمز عبور"
                      v-model="password"
                      class="w-full mt-6" />
                  <span class="text-danger text-sm">{{ errors.first('password') }}</span>

                  <div class="flex flex-wrap justify-between my-5">
                    <!-- <vs-checkbox v-model="checkbox_remember_me" class="mb-3">مرا به خاطر بسپار</vs-checkbox> -->
                    <router-link to="/pages/resetPassword">فراموشی رمز عبور</router-link>
                  </div>
                  <vs-button class="float-right mb-4" @click="loginAdmin()" :disabled="!validateForm">ورود</vs-button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { Validator } from 'vee-validate';

const dict = {
  custom: {
    email: {
      required: 'وارد کردن ایمیل الزامی است.*',
    },
    password: {
      required: 'وارد کردن پسورد الزامی است.*',
    },
  }
};

// register custom messages
Validator.localize('en', dict);

export default{
  data() {
    return {
      email: "",
      password: "",
      checkbox_remember_me: false,

      
    }
  },

  computed: {
    validateForm() {
      return !this.errors.any() && this.email != '' && this.password != '';
    },
  },

  created(){
    this.$vs.loading.close()
  },

  methods: {
    loginAdmin() {
      this.$vs.loading()
      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          email: this.email,
          password: this.password
        }
      }
      this.$store.dispatch('loginAdmin', payload)
      .then(() => { 
        this.$vs.loading.close() 
        return this.$store.state.AppActiveUser 
      })
      .catch(() => {
        this.$vs.loading.close()
        this.$vs.notify({
          title: '',
          text: 'ایمیل یا رمز عبور نامعتبر است.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      })
    },
  }
}
</script>

<style lang="scss">

</style>
